import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import Axios from 'axios'
import { toast } from 'react-toastify'
import { refreshUser } from 'src/ducks/auth'
import { fixedAssets } from 'src/containers/PreCache'
import config from 'src/config'
import { COLORS, SIZES } from 'src/styles/theme'

const Wrapper = styled.div`
  text-align: center;
  
  #formContainer {
    position: fixed;
    left: 0%;
    right: 0%;
    margin: auto;
    max-width: 600px;
    opacity: 0;
    animation: flyUp 700ms 2000ms forwards;
    color: #fff;

    .flexBox {
      display: flex;
      align-items: center;
    } 
    .message {
      width: 70%;
      font-size: 16px;
      margin: 0 auto;
      margin-top: 2rem;
    }
    img {
      position: relative;
      height: 375px;
      max-width: 600px;
    }
    #inputContainer {
      position: absolute;
      top: 10%;
      width: 100%;
    }
    label {
      color: #fff;
      font-weight: 500;
      display: block;
      font-size: 14px;
      text-align: center;
      margin-top: 20px;
    }
    input {
      width: 70%;
      background: ${COLORS.lightGray};
      border: none;
      padding: 6px 20px;
      border-radius: 0px;
      font-size: 14px;
      text-align: center;
      font-weight: 500;

      &::placeholder {
        color: ${COLORS.lightGray1};
      }
    }
    .login-btn {
      margin: auto;
      margin-top: 1em;
      margin-bottom: 1em;
      border-radius: 8px;
      letter-spacing: 1px;
      background: #9419C1;
      border: 2px solid #B101B3;
      cursor: pointer;
      width: 40%;

      input[type="submit"] {
        cursor: pointer;
        font-size: 14px;
        font-weight: 600;
        color: #fff;
        background: transparent;
        padding: 0;
        border: none;
        margin: 0;
      }
    }
  }
  ${SIZES.mobile} {
    #formContainer {
      top: 30%;
    }
  }
`

export default function NicknameForm({ currentUser }) {
  const dispatch = useDispatch()

  const [showModal, setShowModal] = useState(currentUser.nickname ? false : true)
  const [nickname, setNickname] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)


  const handleRequest = (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    if (nickname.length > 0) {
      Axios.post(`${config.apiUrl}/api/update_nickname`, {nickname: nickname}, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        },
      })
      .then((result) => {
        if (result.status === 200) {
          refreshUser(dispatch)
          setShowModal(false)
          toast(`Hello ${result.data.user.nickname}, welcome to ${config.eventName}!`)
        }
        setIsSubmitting(false)
      })
      .catch((err) => {
        setIsSubmitting(false)
        toast(err.response.data.message)
      })
    }
  } 
  if (showModal) {
    return (
      <Wrapper>
        <form id="formContainer" onSubmit={handleRequest}>
          <img src={fixedAssets.nicknameBg} className="w-100" alt="login-form" />
          <div className='flexBox'>
            <div id="inputContainer">
              <p className='message'>You are encouraged to visit and participate in all THREE (3) booths to receive a surprise personalised gift</p>
              <>
                <label>Enter your nickname here</label>
                <input type="text" placeholder="Nickname" value={nickname} onChange={(e) => setNickname(e.target.value)} />
              </>
              <div className="btn login-btn" onClick={handleRequest} style={{ background: isSubmitting ? 'lightgray' : '#9419C1' }}>
                <input disabled={!(nickname.length) || isSubmitting} type="submit" value={isSubmitting ? 'Submitting...' : 'Submit'} />
              </div>
            </div>
          </div>
        </form>
      </Wrapper>
    )
  }
  return <></>         
}
